export const AccountDeactivation = {
    sectionTitle: "uiText.accountDeactivation.sectionTitle",
    subtitle: "uiText.accountDeactivation.subtitle",
    deactivateLink: "uiText.accountDeactivation.deactivateLink",
    deactivateMembershipBtn: "uiText.accountDeactivation.deactivateMembershipBtn",
    deactivateAccountBtn: "uiText.accountDeactivation.deactivateAccountBtn",
    cancelButton: "uiText.accountDeactivation.cancelButton",
    newsletterHeader: "uiText.accountDeactivation.newsletterHeader",
    success: {
        title: "uiText.accountDeactivation.success.title",
        description: "uiText.accountDeactivation.success.description",
    },
    newsletterError: {
        title: "uiText.accountDeactivation.newsletterError.title",
        description: "uiText.accountDeactivation.newsletterError.description",
    },
} as const;
